import React, { useState } from "react";
import style from "../style/dashboard.module.css";
import Card from "./Card";
import {
  converterParaNumero,
  conveterParaMonetario,
} from "../function/funcionalidades";
import { useData } from "../function/method_desp_rec";
import Vazio from "./Vazio";
import ModalEdit from "../components/ModalEdit";

export default function Dashboard({
  conteudo,
  list = [],
  comMes,
  listaVaziaDe,
  colocarFiltroParaLista,
}) {
  const [idEditando, setId] = useState(null);
  const { somar, deletarGasto, deletarReceita, alterarGasto, alterarReceita } =
    useData();

  const [modal, setModal] = useState(false);
  const [comCampoMes, setComCampoMes] = useState("");

  const [nome, setNome] = useState("");
  const [valor, setValor] = useState("");
  const [mes, setMes] = useState("");

  let tot = somar(list);


  const acionarModalGasto = (item) => {
    setModal(true);
    setId(item.id);
    setNome(item.nome);
    setValor(item.valor);
    setMes(item.mes);
    setComCampoMes(true);
  };

  const acionarModalReceita = (item) => {
    setModal(true);
    setId(item.id);
    setNome(item.nome);
    setValor(item.valor);
    setComCampoMes(false);
  };

  const alerta = (novoNome, novoValor, novoMes) => {
    setModal(false);
    
    const valoreditado = converterParaNumero(novoValor);
    
    if (comCampoMes) {
      alterarGasto(idEditando, novoNome, valoreditado, novoMes);
    } else {
      alterarReceita(idEditando, novoNome, valoreditado);
    }
  };

  
  return (
    <section className={style.painel}>
      <header className={style.total}>
        <h2 className={style.title}>Total</h2>
        <p className={style.valor}>{conveterParaMonetario(tot)}</p>
      </header>
      <h3 className={style.conteudo}>{conteudo}</h3>
      {modal && (
        <ModalEdit
          isOpen={modal}
          setOpen={() => setModal(false)}
          getMes={mes}
          getNome={nome}
          getValor={conveterParaMonetario(valor)}
          comCampoMes={comCampoMes}
          onPress={alerta}
        />
      )}
      <ul className={style.scrollView}>
        {list.length === 0 ? (
          <li style={{ listStyle: "none" }}>
            <Vazio listaVaziaDe={listaVaziaDe} />
          </li>
        ) : (
          list.map((item, index) => (
            <li key={index} style={{ listStyle: "none" }}>
              {comMes === true ? (
                <Card
                  title={item.nome}
                  valor={conveterParaMonetario(item.valor)}
                  mes={item.mes}
                  onPressDelete={() => deletarGasto(item.id)}
                  onPressEdit={() => acionarModalGasto(item)}
                />
              ) : (
                <Card
                  title={item.nome}
                  valor={conveterParaMonetario(item.valor)}
                  onPressDelete={() => deletarReceita(item.id)}
                  onPressEdit={() => acionarModalReceita(item)}
                />
              )}
            </li>
          ))
        )}
      </ul>
    </section>
  );
}
